import { twMerge } from "tailwind-merge";
import logo from "../assets/images/Medibyt logo.svg";
import logo2 from "../assets/images/Medibyt logo 2.png";

export default function Logo({
    className,
    variant = "CPETWise",
}: {
    className?: string;
    variant?: "CPETWise" | "Medibyt";
}) {
    return (
        <img
            src={variant === "CPETWise" ? logo : logo2}
            alt="Medibyt Logo"
            className={twMerge(
                variant === "CPETWise" ? "w-[130px]" : "w-auto",
                className
            )}
        />
    );
}
